var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Jinwoo Park
 * @contact libfairy720@datasolution.kr
 * @date 2023-06-28
 * @brief SEI 운영관리 -main 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { adminApprovalState, adminTypeState, curAdminTreeState } from "../../../recoil/assessmentState";
import { reLoadPage } from "../../../recoil/userState";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
// utils
import { useDebounceEffect } from "@components/dashBoard/operationmanagement/OperationManagementMain";
import { alertState } from "../../../recoil/assessmentState";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import { useTrans } from "../../../utils/langs/useTrans";
// component
function OperationManagementView(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilType = useSetRecoilState(adminTypeState);
    const recoilApproval = useRecoilValue(adminApprovalState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    // props
    const { handleOpenPop } = props;
    // useState
    const [subZoneInfo, setSubZoneInfo] = useState([]);
    const [roomInfo, setRoomInfo] = useState([]);
    const [chnanTree, setChnanTree] = useState(null);
    // Mobile Check용
    const [isMobile, setMobile] = useState(false);
    useEffect(() => {
        // resize handler
        // Mobile 체크
        function handleResize() {
            if (window.innerWidth <= 940) {
                setMobile(true);
            }
            else {
                setMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.innerWidth <= 940) {
            setMobile(true);
        }
    }), 100);
    useEffect(() => {
        handleOpenPop("pop-memo2", _jsx(MemoPop, { htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.반려") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-memo2") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        handleOpenPop("pop-cancel2", _jsx(CancelPop, {}));
    }, []);
    // SubZone
    function SubZoneSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/zone/${recoilTree.zone.zoneId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            setChnanTree(recoilTree);
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSubZoneInfo(data.body);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function onClickSubZone(item) {
        setRecoilTree(Object.assign(Object.assign({}, recoilTree), { subZone: { subZoneId: item.subZoneId, subZoneName: item.subZoneName }, room: { roomId: "", roomName: "" } }));
        setRecoilType("subZone");
        let zone_class = document.querySelector(".add");
        zone_class.classList.add("nobg");
        if (recoilTree.room.roomId) {
            let subzone_class = document.querySelector(".szadd");
            subzone_class.classList.remove("nobg");
        }
    }
    // SubZone
    function RoomSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/subzone/${recoilTree.subZone.subZoneId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            setChnanTree(recoilTree);
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setRoomInfo(data.body);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function onClickRoom(item) {
        if (item == "all") {
            setRecoilTree(Object.assign(Object.assign({}, recoilTree), { subZone: {
                    subZoneId: recoilTree.subZone.subZoneId,
                    subZoneName: recoilTree.subZone.subZoneName,
                }, room: { roomId: "", roomName: "" } }));
            setRecoilType("subZone");
            let zone_class = document.querySelector(".add");
            zone_class.classList.add("nobg");
            let subzone_class = document.querySelector(".szadd");
            subzone_class.classList.remove("nobg");
        }
        else {
            setRecoilTree(Object.assign(Object.assign({}, recoilTree), { room: { roomId: item.roomId, roomName: item.roomName } }));
            setRecoilType("room");
            let zone_class = document.querySelector(".add");
            zone_class.classList.add("nobg");
            let subzone_class = document.querySelector(".szadd");
            subzone_class.classList.add("nobg");
        }
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "flex-inline gap-24 m-none" }, { children: [_jsxs("div", Object.assign({ className: "select subzone", onClick: (e) => recoilTree.subZone.subZoneId && SubZoneSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: recoilTree.subZone.subZoneId
                                        ? recoilTree.company.companyName + " " + recoilTree.zone.zoneName + "_" + recoilTree.subZone.subZoneName
                                        : recoilTree.company.companyName + " " + recoilTree.zone.zoneName })), _jsx("div", { className: recoilTree.subZone.subZoneId ? "arrow" : "" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickSubZone("all") }, { children: t("라벨.전체") })), subZoneInfo.length > 0 &&
                                    subZoneInfo.map((info, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickSubZone(info) }, { children: recoilTree.company.companyName + " " + recoilTree.zone.zoneName + "_" + info.subZoneName }), "subZone_" + idx.toString())))] })] })), recoilTree.subZone.subZoneId && (_jsxs("div", Object.assign({ className: "select room", onClick: (e) => RoomSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": recoilTree.room.roomId ? recoilTree.room.roomName : "" }, { children: recoilTree.room.roomId ? recoilTree.room.roomName : t("라벨.전체") })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickRoom("all") }, { children: t("라벨.전체") })), roomInfo.length > 0 &&
                                    roomInfo.map((info, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickRoom(info) }, { children: info.roomName }), "room_" + idx.toString())))] })] }))), recoilApproval.approval == 0 ? (_jsxs("div", Object.assign({ className: `request-cond js-open ok`, "data-pop": "pop-memo2", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: [_jsx("p", Object.assign({ className: "request-cond" }, { children: t("라벨.요청반려") })), _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.확인") }))] }))) : recoilApproval.approval == 1 ? (_jsxs("div", Object.assign({ className: `request-cond js-open `, "data-pop": "pop-cancel2", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: [_jsx("p", Object.assign({ className: "request-cond" }, { children: t("라벨.추가요청중") })), _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.취소") }))] }))) : recoilApproval.approval == 4 ? (
                // <div className={`request-cond js-open ok`} data-pop={(recoilApproval.approval > 4) ? "pop-memo2" : ""} onClick={(e) => CUTIL.jsopen_Popup(e)}> {/* ${(recoilApproval.approval == 5) ? "ok" : ""} */}
                _jsxs("div", Object.assign({ className: `request-cond js-open ok` }, { children: [" ", _jsx("p", Object.assign({ className: "request-cond" }, { children: t("라벨.삭제요청중") })), _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.확인") }))] }))) : (recoilApproval.approval == 5 && (
                // <div className={`request-cond js-open ok`} data-pop={(recoilApproval.approval > 4) ? "pop-memo2" : ""} onClick={(e) => CUTIL.jsopen_Popup(e)}> {/* ${(recoilApproval.approval == 5) ? "ok" : ""} */}
                _jsxs("div", Object.assign({ className: `request-cond js-open ok` }, { children: [" ", _jsx("p", Object.assign({ className: "request-cond" }, { children: t("라벨.삭제반려") })), _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.확인") }))] }))))] })) }));
}
export default OperationManagementView;
function MemoPop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilApproval, setrecoilApproval] = useRecoilState(adminApprovalState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [checked, setChecked] = useState(true);
    function onChangeChecked(e) {
        if (checked) {
            setChecked(false);
        }
        else {
            setChecked(true);
        }
    }
    function Delete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            if (recoilApproval.approval > 4) {
                CUTIL.jsclose_Popup("pop-memo2");
            }
            else {
                if (checked) {
                    data = yield HTTPUTIL.PromiseHttp({
                        httpMethod: "DELETE",
                        appPath: `/product/usertree?productId=${recoilTree.zone.zoneId}`,
                        appQuery: {},
                        userToken: userInfo.loginInfo.token,
                    });
                    if (data) {
                        if (data.codeNum == CONST.API_200) {
                            CUTIL.jsclose_Popup("pop-memo2");
                            setAlert(Object.assign(Object.assign({}, alert), { layerId: CONST.POP_RELOAD, type: CONST.TYPE_NONE, divTag: t("라벨.삭제되었습니다") }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                            setChecked(true);
                        }
                        else {
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                            CUTIL.jsclose_Popup("pop-memo2");
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                    }
                }
                else {
                    CUTIL.jsclose_Popup("pop-memo2");
                    setChecked(true);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.반려사유") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { className: "h142", readOnly: true, value: recoilApproval ? recoilApproval.deniedReason : "" }), recoilApproval.approval <= 4 && (_jsxs("div", Object.assign({ className: "mt-8" }, { children: [_jsx("input", { type: "checkbox", id: "t_1", checked: checked ? true : false, onChange: (e) => onChangeChecked(e) }), _jsxs("label", Object.assign({ htmlFor: "t_1", className: "w-auto" }, { children: [" ", t("라벨.사업장추가요청을취소합니다")] }))] })))] }))] }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-memo2") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => Delete(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function CancelPop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReloadPages = useSetRecoilState(reLoadPage);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const [alert, setAlert] = useRecoilState(alertState);
    // 엔지니어 승인 API
    function ApprovalCancel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/product/usertree?productId=${recoilTree.zone.zoneId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadPages(true);
                    CUTIL.jsclose_Popup("pop-cancel2");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: CONST.POP_RELOAD, type: CONST.TYPE_NONE, divTag: t("라벨.삭제되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadPages(false);
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                    CUTIL.jsclose_Popup("pop-cancel2");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.요청을취소하시겠습니까") }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-cancel2") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => ApprovalCancel(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
